import { defineComponent as _defineComponent } from 'vue'
import { getAssetsUrl } from '@/utils/index'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewImage',
  props: {
    src: null,
    hover: { type: Boolean, default: true },
    errorHide: { type: Boolean }
  },
  emits: ['click', 'error'],
  setup(__props: any, { emit }) {

const props = __props as { src: string, hover: boolean, errorHide?: boolean };




function handleClick() {
  emit('click')
}

const hide = ref(false)
function handleError() {
  if (props.errorHide) {
    hide.value = true
  }
  emit('error')
}

return { __sfc: true,props, emit, handleClick, hide, handleError, getAssetsUrl }
}

})